import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhBhpConsumptionComponent } from './ph-bhp-consumption/ph-bhp-consumption.component';
import { PhBhpConsumptionsPatientComponent } from './ph-bhp-consumptions-patient/ph-bhp-consumptions-patient.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { PhBhpObserveStaticalEvaluationComponent } from './ph-bhp-observe-statical-evaluation/ph-bhp-observe-statical-evaluation.component';
import { PhBhpConsumptionStaticalEvaluationComponent } from './ph-bhp-consumption-statical-evaluation/ph-bhp-consumption-statical-evaluation.component';
import { PhBhpObserveOverallComplianceComponent } from './ph-bhp-observe-overall-compliance/ph-bhp-observe-overall-compliance.component';
import { PhBhpObserveChartExportComponent } from './ph-bhp-observe-chart-export/ph-bhp-observe-chart-export.component';
import { PhBhpObserveFivemomentsComponent } from './ph-bhp-observe-fivemoments/ph-bhp-observe-fivemoments.component';
import { ObserveSopComponent } from './observeSop/observeSop.component';
import { ReportSopComponent } from './reportSop/reportSop.component';
import { SopStatisticalComponent } from './sopStatistical/sopStatistical.component';
import { SopProcessComplianceComponent } from './sopProcessCompliance/sopProcessCompliance.component';
import { SopSubStepComplianceComponent } from './sopSubStepCompliance/sopSubStepCompliance.component';
import { sopCommentsComponent } from './sopComments/sopComments.component';
import { SopIndividualOverviewComponent } from './sopIndividualOverview/sopIndividualOverview.component';
import { SopFrequencyDistributionComponent } from './sopFrequencyDistribution/sopFrequencyDistribution.component';

import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageEvaluationModule} from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PhBhpObserveOverviewindividualdataComponent } from './ph-bhp-observe-overviewindividualdata/ph-bhp-observe-overviewindividualdata.component';
import { PhBhpObserveStatisticsBeforeAsepticProceduresComponent } from './ph-bhp-observe-statistics-before-aseptic-procedures/ph-bhp-observe-statistics-before-aseptic-procedures.component';
import { PhBhpObserveQuotaComponent } from './ph-bhp-observe-quota/ph-bhp-observe-quota.component';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { PhBhpConsumptionChartExportComponent } from './ph-bhp-consumption-chart-export/ph-bhp-consumption-chart-export.component';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { PhBhpObserveCommentsComponent } from './ph-bhp-observe-comments/ph-bhp-observe-comments.component';
import { ClientLibModule } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { HygieneCheckComponent } from './hygiene-check/hygiene-check.component';
import { HygieneCheckStatisticalComponent } from './hygiene-check-statistical/hygiene-check-statistical.component';
import { PHBHPFeaturePackageCheckModule } from '../check/hygiene-check-package.module';
import { PhBhpFeatureComponentsModule } from 'ph-bhp-feature-packages/ph-bhp-feature-components/public_api';

// common libraries


@NgModule({
  declarations: [
    EvaluationComponent,
    ObserveSopComponent,
    ReportSopComponent,
    SopStatisticalComponent,
    SopProcessComplianceComponent,
    SopSubStepComplianceComponent,
    sopCommentsComponent,
    SopIndividualOverviewComponent,
    SopFrequencyDistributionComponent,
    PhBhpObserveStatisticsBeforeAsepticProceduresComponent,
    PhBhpObserveStaticalEvaluationComponent,
    PhBhpObserveOverallComplianceComponent,
    PhBhpObserveChartExportComponent,
    PhBhpObserveFivemomentsComponent,
    PhBhpObserveOverviewindividualdataComponent,
    PhBhpObserveQuotaComponent,
    PhBhpConsumptionStaticalEvaluationComponent,
    PhBhpConsumptionComponent,
    PhBhpConsumptionsPatientComponent,
    PhBhpConsumptionChartExportComponent,
    PhBhpObserveCommentsComponent,
    HygieneCheckComponent,
    HygieneCheckStatisticalComponent
  ],
  imports: [
    CommonModule,
    PHBHPLocalizePackageModule,
    PHBHPLayoutPackageModule,
    PHBHPFeaturePackageEvaluationModule,
    ExcelExportModule,
    PDFExportModule,
    PhBhpUiModule,
    ClientLibModule,
    PHBHPFeaturePackageCheckModule,
    PhBhpFeatureComponentsModule
  ]
})
export class EvaluationModule { }
